const ROOTS = {
  HOME_ED: '/home-ed',
  HOME_ED_FACILITATORS: '/home-ed-facilitators',
  HOME_ED_FAMILIES: '/home-ed-families',
  AUTH: '/auth',
  DASHBOARD: '/',
  LANDING: '/landing',
  STUDENT: '/student',
  PROFILEREVIEW: '/profile-review',
  HOME_ED_RENEWAL: '/home-ed-renewal',
  HOME_ED_PROGRAM_PLAN: '/home-ed-program-plan',
  ENROLLMENT: '/enrollment',
  HOME_ED_REGISTRATION: '/home-ed-registration',
  ASSESSMENTS: '/assessments',
  VEHICLE: '/vehicle',
  PART: '/part',
  WORKORDER: '/workorder',
  PURCHASE_ORDER: '/purchase-order',
  CROSS_BOUNDARY: '/crossboundary-request',
  ROUTING: '/routing-request',
  SCHOOL_YEAR: '/school-year',
  FILE_EXPORT: '/file-export',
  BUS_ROUTES: '/bus-routes',
  STUDENT_CAREERS: '/careers',
  SCREEN_SHARE: '/screenshare',
  DEVICES: '/devices',
  DEVICE: '/device',
  BUILDINGS: '/buildings',
  EMPLOYEE_PROCESSING: '/employee-processing',
  OFF_CAMPUS: '/off-campus',
};

// A path with a query string from { key: value }; empty values are left out
const withQuery = (path, query = {}) => {
  const qs = new URLSearchParams(Object.entries(query).filter(([, v]) => v != null && v !== '')).toString();
  return qs ? `${path}?${qs}` : path;
};

// ----------------------------------------------------------------------

export const paths = {
  page403: '/403',
  page404: '/404',
  page500: '/500',
  // AUTH
  auth: {
    amplify: {
      login: `${ROOTS.AUTH}/amplify/login`,
      verify: `${ROOTS.AUTH}/amplify/verify`,
      register: `${ROOTS.AUTH}/amplify/register`,
      newPassword: `${ROOTS.AUTH}/amplify/new-password`,
      forgotPassword: `${ROOTS.AUTH}/amplify/forgot-password`,
    },
    jwt: {
      login: `/login`,
      register: `${ROOTS.AUTH}/jwt/register`,
      pair: '/pair',
    },
    firebase: {
      login: `${ROOTS.AUTH}/firebase/login`,
      verify: `${ROOTS.AUTH}/firebase/verify`,
      register: `${ROOTS.AUTH}/firebase/register`,
      forgotPassword: `${ROOTS.AUTH}/firebase/forgot-password`,
    },
    auth0: {
      login: `${ROOTS.AUTH}/auth0/login`,
    },
  },
  // DASHBOARD
  dashboard: ROOTS.DASHBOARD,
  // LANDING
  landing: ROOTS.LANDING,
  // STUDENT
  student: {
    root: ROOTS.STUDENT,
    profile: (asn) => `${ROOTS.STUDENT}/${asn}`,
    homeEd: (asn) => `${ROOTS.STUDENT}/${asn}?tab=home-ed`,
    career: (asn) => `${ROOTS.STUDENT}/${asn}/?tab=career`,
    careersDashboard: `careers-dashboard`,
  },
  // PROFILE REVIEW
  profileReview: {
    root: ROOTS.PROFILEREVIEW,
    edit: (profileReviewId) => `${ROOTS.PROFILEREVIEW}/${profileReviewId}`,
    start: (profileReviewId) => `${ROOTS.PROFILEREVIEW}/${profileReviewId}/start`,
    form: (profileReviewId) => `${ROOTS.PROFILEREVIEW}/${profileReviewId}/form`,
    confirmation: (profileReviewId) => `${ROOTS.PROFILEREVIEW}/${profileReviewId}/confirmation`,
  },
  homeEd: {
    dashboard: ROOTS.HOME_ED,
    unassigned: `${ROOTS.HOME_ED}/unassigned`,
  },
  homeEdRenewal: {
    root: ROOTS.HOME_ED_RENEWAL,
    edit: (renewalId) => `${ROOTS.HOME_ED_RENEWAL}/${renewalId}`,
    start: (renewalId) => `${ROOTS.HOME_ED_RENEWAL}/${renewalId}/start`,
    form: (renewalId) => `${ROOTS.HOME_ED_RENEWAL}/${renewalId}/form`,
    confirmation: (renewalId) => `${ROOTS.HOME_ED_RENEWAL}/${renewalId}/confirmation`,
  },
  homeEdFacilitators: {
    root: ROOTS.HOME_ED_FACILITATORS,
    detail: (externalId) => `${ROOTS.HOME_ED_FACILITATORS}/${externalId}`,
  },
  homeEdFamilies: {
    root: ROOTS.HOME_ED_FAMILIES,
    detail: (id) => `${ROOTS.HOME_ED_FAMILIES}/${id}`,
  },
  homeEdProgramPlan: {
    root: ROOTS.HOME_ED_PROGRAM_PLAN,
    edit: (planId) => `${ROOTS.HOME_ED_PROGRAM_PLAN}/${planId}`,
    start: (planId) => `${ROOTS.HOME_ED_PROGRAM_PLAN}/${planId}/start`,
    form: (planId) => `${ROOTS.HOME_ED_PROGRAM_PLAN}/${planId}/form`,
    confirmation: (planId) => `${ROOTS.HOME_ED_PROGRAM_PLAN}/${planId}/confirmation`,
  },
  enrollment: {
    root: ROOTS.ENROLLMENT,
    edit: (enrollmentId) => `${ROOTS.ENROLLMENT}/${enrollmentId}`,
  },
  homeEdRegistrationAdmin: {
    root: ROOTS.HOME_ED_REGISTRATION,
    edit: (registrationId) => `${ROOTS.HOME_ED_REGISTRATION}/${registrationId}`,
  },
  assessments: {
    root: ROOTS.ASSESSMENTS,
    wrat5: `${ROOTS.ASSESSMENTS}/wrat5`,
    lens: `${ROOTS.ASSESSMENTS}/lens`,
    adlof: `${ROOTS.ASSESSMENTS}/adlof`,
    new: `${ROOTS.ASSESSMENTS}/new`,
    details: (type, assessmentId) => `${ROOTS.ASSESSMENTS}/${type}/${assessmentId}`,
  },
  crossboundary: {
    root: ROOTS.CROSS_BOUNDARY,
  },
  routing: {
    root: ROOTS.ROUTING,
    routesList: `routes`,
  },
  busRoutes: {
    root: ROOTS.BUS_ROUTES,
    details: (routeId) => `${ROOTS.BUS_ROUTES}/${routeId}`,
    driverView: (routeId) => `${ROOTS.BUS_ROUTES}/${routeId}/driver`,
  },
  schoolYear: {
    root: ROOTS.SCHOOL_YEAR,
  },
  fileExport: {
    root: ROOTS.FILE_EXPORT,
  },

  // VEHICLE
  vehicle: {
    root: ROOTS.VEHICLE,
    new: `${ROOTS.VEHICLE}/new`,
    edit: (vehicleId) => `${ROOTS.VEHICLE}/${vehicleId}/edit`,
    details: (vehicleId) => `${ROOTS.VEHICLE}/${vehicleId}`,
  },
  // PART
  part: {
    root: ROOTS.PART,
    new: `${ROOTS.PART}/new`,
    edit: (partId) => `${ROOTS.PART}/${partId}/edit`,
  },
  // WORK ORDER
  workOrder: {
    root: ROOTS.WORKORDER,
    new: `${ROOTS.WORKORDER}/new`,
    edit: (workOrderId) => `${ROOTS.WORKORDER}/${workOrderId}/edit`,
  },
  // PURCHASE ORDER
  purchaseOrder: {
    root: ROOTS.PURCHASE_ORDER,
    new: `${ROOTS.PURCHASE_ORDER}/new`,
    edit: (purchaseOrderId) => `${ROOTS.PURCHASE_ORDER}/${purchaseOrderId}/edit`,
  },

  // STUDENT CAREERS
  careers: {
    root: ROOTS.STUDENT_CAREERS,
    profiles: `${ROOTS.STUDENT_CAREERS}/profiles`,
    profile: (profileId) => `${ROOTS.STUDENT_CAREERS}/profiles/${profileId}`,
    businesses: `${ROOTS.STUDENT_CAREERS}/businesses`,
  },
  // BUILDINGS
  buildings: {
    root: ROOTS.BUILDINGS,
    new: `${ROOTS.BUILDINGS}/new`,
    details: (id) => `${ROOTS.BUILDINGS}/${id}`,
    newFile: (id) => `${ROOTS.BUILDINGS}/${id}/files/new`,
    fileDetails: (id, fileId) => `${ROOTS.BUILDINGS}/${id}/files/${fileId}`,
    editFile: (id, fileId) => `${ROOTS.BUILDINGS}/${id}/files/${fileId}/edit`,
  },
  // SCREEN SHARE
  screenShare: {
    root: ROOTS.SCREEN_SHARE,
    share: `${ROOTS.SCREEN_SHARE}/share`,
    join: `${ROOTS.SCREEN_SHARE}/view`,
  },
  // DEVICES
  devices: {
    root: ROOTS.DEVICES,
  },
  employeeProcessing: {
    root: ROOTS.EMPLOYEE_PROCESSING,
  },
  // The student's own dashboard (#633): their placements, career plan and to-dos.
  // /my-placement was its first address (#603); it redirects here.
  studentDashboard: {
    root: '/dashboard',
    placement: (id) => `/dashboard/placements/${id}`,
  },
  myPlacement: '/my-placement',
  offCampus: {
    root: ROOTS.OFF_CAMPUS,
    // The lists; `query` is a filter like { status: 'pending' }
    referrals: (query) => withQuery(`${ROOTS.OFF_CAMPUS}/referrals`, query),
    placements: (query) => withQuery(`${ROOTS.OFF_CAMPUS}/placements`, query),
    worksites: (query) => withQuery(`${ROOTS.OFF_CAMPUS}/worksites`, query),
    learningPlan: `${ROOTS.OFF_CAMPUS}/learning-plan`,
    settings: `${ROOTS.OFF_CAMPUS}/settings`,
    referral: (id) => `${ROOTS.OFF_CAMPUS}/referrals/${id}`,
    worksite: (id) => `${ROOTS.OFF_CAMPUS}/worksites/${id}`,
    placement: (id) => `${ROOTS.OFF_CAMPUS}/placements/${id}`,
  },
  employerEval: {
    token: (token) => `/employer-eval/${token}`,
  },
  device: {
    root: ROOTS.DEVICE,
    route: (routeId) => `${ROOTS.DEVICE}/bus-routes/${routeId}`,
    run: (runId) => `${ROOTS.DEVICE}/runs/${runId}`,
  },
};
